import type { BrowserRuntime, SupportSessionStatus } from '@br/protocol';
import { RUNTIME_LABEL, RUNTIME_TONE, STATUS_LABEL, STATUS_TONE } from '../lib/labels';
import { Badge } from './ui';

export function StatusBadge({ status }: { status: SupportSessionStatus }) {
  return <Badge tone={STATUS_TONE[status]}>{STATUS_LABEL[status]}</Badge>;
}

export function RuntimeBadge({ runtime }: { runtime: BrowserRuntime }) {
  return <Badge tone={RUNTIME_TONE[runtime]}>{RUNTIME_LABEL[runtime]}</Badge>;
}
